<div class="iwb-drawer-host iwb-nodim">
  <div class="backdrop" (click)="close()"></div>
  <div class="drawer" *ngIf="t" [style.width.px]="drawerWidth">
    <button
      type="button"
      class="iwb-drawer-resizer"
      title="Resize panel"
      irembogovRealtimeResize
      irembogovRealtimeResizeTargetSelector=".drawer"
      irembogovRealtimeResizeUnit="px"
      irembogovRealtimeResizeEdge="left"
      irembogovRealtimeResizeBodyClass="iwb-resizing-drawer"
      [irembogovRealtimeResizeValue]="drawerWidth"
      [irembogovRealtimeResizeMin]="minDrawerWidth"
      [irembogovRealtimeResizeMax]="maxDrawerResizeWidth"
      (irembogovRealtimeResizeCommitted)="
        onDrawerResizeCommitted($event)
      "></button>
    <div class="dhead">
      <button
        *ngIf="target.mode === 'action'"
        type="button"
        class="iwb-back-state iwb-back-state--head"
        title="Back to state"
        aria-label="Back to state"
        (click)="backToState()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <div>
        <div class="dtype" [ngSwitch]="target.mode">
          <span *ngSwitchCase="'state'"
            >State ·
            {{
              target.which === 'two' ? 'End State Two' : 'End State One'
            }}</span
          >
          <span *ngSwitchCase="'action'">Action · {{ target.stateName }}</span>
          <span *ngSwitchCase="'event'">Event configuration</span>
          <span *ngSwitchCase="'condition'">Decision · endStateCondition</span>
        </div>
        <div class="dtitle" [ngSwitch]="target.mode">
          <b *ngSwitchCase="'state'">{{
            target.stateName || endState?.stateCode
          }}</b>
          <b *ngSwitchCase="'action'">{{
            currentAction ? meta(currentAction).plain : 'Action'
          }}</b>
          <b *ngSwitchCase="'event'">{{ t.event }}</b>
          <b *ngSwitchCase="'condition'">{{ t.event }}</b>
        </div>
      </div>
      <button class="dx" (click)="close()">✕</button>
    </div>

    <div class="dbodywrap">
      <!-- STATE: properties — a clickable list of actions (edit one at a time) + state JSON -->
      <ng-container *ngIf="target.mode === 'state'">
        <div class="iwb-inspector-tabs">
          <button
            type="button"
            class="iwb-itab"
            [class.on]="stateTab === 'properties'"
            (click)="selectStateTab('properties')"
            title="Properties">
            <i class="fa-solid fa-gear"></i><span>Properties</span>
          </button>
          <button
            type="button"
            class="iwb-itab"
            [class.on]="stateTab === 'json'"
            (click)="selectStateTab('json')"
            title="JSON">
            <i class="fa-solid fa-code"></i><span>JSON</span>
          </button>
        </div>

        <div *ngIf="stateTab === 'properties'">
          <div class="dgrp">State details</div>
          <div class="dcard state-edit-card">
            <div class="dfield">
              <label>State name</label>
              <input
                class="inp"
                [(ngModel)]="stateNameDraft"
                placeholder="Payment pending" />
            </div>
            <div class="dfield">
              <label>State code</label>
              <ng-select
                class="iwb-dest"
                [items]="stateOptions"
                bindValue="code"
                [(ngModel)]="stateCodeDraft"
                [searchable]="true"
                [clearable]="false"
                [searchFn]="searchState"
                [addTag]="addStateCodeTag"
                addTagText="Use custom code:"
                placeholder="Search a state code or name…"
                dropdownPosition="auto"
                (change)="onStateCodePicked($event)">
                <ng-template ng-label-tmp let-item="item">
                  <span
                    class="iwb-dot"
                    [style.background]="item.colour || 'transparent'"></span>
                  <span class="iwb-opt-code">{{ item.code }}</span
                  ><small
                    class="iwb-opt-name"
                    *ngIf="item.name && item.name !== item.code">
                    — {{ item.name }}</small
                  >
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span
                    class="iwb-dot"
                    [style.background]="item.colour || 'transparent'"></span>
                  <span class="iwb-opt-text">
                    <small
                      class="iwb-opt-name"
                      *ngIf="item.name && item.name !== item.code"
                      >{{ item.name }}</small
                    >
                    <span class="iwb-opt-code">{{ item.code }}</span>
                  </span>
                </ng-template>
              </ng-select>
            </div>
            <button
              type="button"
              class="dgrp iwb-collapsible-section-title"
              (click)="toggleStateNamesExpanded()">
              <span>State names (applicant-facing)</span>
              <i
                class="fa-solid"
                [ngClass]="
                  stateNamesExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
                "></i>
            </button>
            <ng-container *ngIf="stateNamesExpanded">
              <div class="dfield">
                <label>Language</label>
                <select
                  class="selx iwb-notification-select"
                  [ngModel]="selectedStateNameLocale"
                  (ngModelChange)="selectStateNameLocale($event)">
                  <option
                    *ngFor="let locale of localeFields; trackBy: trackByLocale"
                    [value]="locale.key">
                    {{ locale.label }} · {{ locale.key }}
                  </option>
                </select>
              </div>
              <div class="dfield">
                <label>State name</label>
                <input
                  class="inp"
                  [value]="stateLocalizedName(selectedStateNameLocale)"
                  (input)="
                    setStateLocalizedName(
                      selectedStateNameLocale,
                      $any($event.target).value
                    )
                  "
                  [placeholder]="stateNameDraft || 'State label'" />
              </div>
            </ng-container>
            <div
              class="iwb-locale-issue iwb-locale-issue--compact"
              *ngIf="missingStateNameLanguages().length">
              <div class="iwb-locale-issue-copy">
                <b>Missing state name translations</b>
                <p>
                  State name is set for
                  {{ missingLanguageLabels(configuredStateNameLanguages()) }}
                  and missing for
                  {{ missingLanguageLabels(missingStateNameLanguages()) }}.
                  Applicants using the missing languages may see a fallback
                  label or state code. Please add the missing state names.
                </p>
              </div>
            </div>
            <button
              type="button"
              class="dgrp iwb-collapsible-section-title"
              (click)="toggleEventNamesExpanded()">
              <span>Event names (office-facing)</span>
              <i
                class="fa-solid"
                [ngClass]="
                  eventNamesExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
                "></i>
            </button>
            <ng-container *ngIf="eventNamesExpanded">
              <div class="dfield">
                <label>Language</label>
                <select
                  class="selx iwb-notification-select"
                  [ngModel]="selectedEventNameLocale"
                  (ngModelChange)="selectEventNameLocale($event)">
                  <option
                    *ngFor="let locale of localeFields; trackBy: trackByLocale"
                    [value]="locale.key">
                    {{ locale.label }} · {{ locale.key }}
                  </option>
                </select>
              </div>
              <div class="dfield">
                <label>Event name</label>
                <input
                  class="inp"
                  [value]="eventName(selectedEventNameLocale)"
                  (input)="
                    setEventName(
                      selectedEventNameLocale,
                      $any($event.target).value
                    )
                  " />
              </div>
            </ng-container>
            <div
              class="iwb-locale-issue iwb-locale-issue--compact"
              *ngIf="missingEventNameLanguages().length">
              <div class="iwb-locale-issue-copy">
                <b>Missing event name translations</b>
                <p>
                  Event name is set for
                  {{ missingLanguageLabels(configuredEventNameLanguages()) }}
                  and missing for
                  {{ missingLanguageLabels(missingEventNameLanguages()) }}.
                  Officers using the missing languages may see a fallback label
                  or event code. Please add the missing event names.
                </p>
              </div>
            </div>
            <div class="dfield">
              <label
                >Next event
                <span style="color: #667085"
                  >(optional — the system runs it automatically on entry)</span
                ></label
              >
              <select
                class="selx"
                [ngModel]="nextEventValue"
                (ngModelChange)="setNextEvent($event)">
                <option value="">— none —</option>
                <option *ngFor="let e of nextEventOptions" [value]="e">
                  {{ e }}
                </option>
              </select>
              <div
                class="dnone"
                *ngIf="!nextEventOptions.length"
                style="margin-top: 4px">
                No events in the workflow yet — add one first, then chain it
                here.
              </div>
            </div>
          </div>

          <div class="dgrp">
            Actions
            <span style="color: #98a2b3; font-weight: 400"
              >· click one to edit</span
            >
          </div>
          <div class="iwb-action-section">
            <div class="iwb-action-section-head">
              <div>
                <b>Breaking actions</b>
                <small>Must complete before the workflow continues.</small>
              </div>
              <irembogov-iwb-variable-token-select
                [variables]="actionPickerOptions"
                label="Add breaking action"
                buttonLabel="Add breaking action"
                placeholder="Search workflow actions"
                popupHelpText="Search and add a workflow action to this state."
                iconClass="fa-plus"
                (tokenSelected)="pickAction($event, true)">
              </irembogov-iwb-variable-token-select>
            </div>
            <div
              class="dcard actrow"
              *ngFor="
                let item of breakingActionItems;
                trackBy: trackByActionIndex
              "
              (click)="actionEdit.emit(item.index)">
              <div class="dch">
                <span class="ci" [ngClass]="meta(item.action).cls"
                  ><i class="fa-solid" [ngClass]="meta(item.action).icon"></i
                ></span>
                <b>{{ meta(item.action).plain }}</b>
                <button
                  class="ddel"
                  title="Remove action"
                  (click)="
                    requestActionDelete(item.index); $event.stopPropagation()
                  ">
                  <i class="fa-solid fa-trash"></i>
                </button>
                <span class="dchev">›</span>
              </div>
            </div>
            <div class="dnone" *ngIf="!breakingActionItems.length">
              No breaking actions yet.
            </div>
          </div>

          <div class="iwb-action-section">
            <div class="iwb-action-section-head">
              <div>
                <b>Non-breaking actions</b>
                <small>Runs without blocking the main transition.</small>
              </div>
              <irembogov-iwb-variable-token-select
                [variables]="actionPickerOptions"
                label="Add non-breaking action"
                buttonLabel="Add non-breaking action"
                placeholder="Search workflow actions"
                popupHelpText="Search and add a workflow action to this state."
                iconClass="fa-plus"
                (tokenSelected)="pickAction($event, false)">
              </irembogov-iwb-variable-token-select>
            </div>
            <div
              class="dcard actrow"
              *ngFor="
                let item of nonBreakingActionItems;
                trackBy: trackByActionIndex
              "
              (click)="actionEdit.emit(item.index)">
              <div class="dch">
                <span class="ci" [ngClass]="meta(item.action).cls"
                  ><i class="fa-solid" [ngClass]="meta(item.action).icon"></i
                ></span>
                <b>{{ meta(item.action).plain }}</b>
                <button
                  class="ddel"
                  title="Remove action"
                  (click)="
                    requestActionDelete(item.index); $event.stopPropagation()
                  ">
                  <i class="fa-solid fa-trash"></i>
                </button>
                <span class="dchev">›</span>
              </div>
            </div>
            <div class="dnone" *ngIf="!nonBreakingActionItems.length">
              No non-breaking actions yet.
            </div>
          </div>
          <button
            class="btn iwb-danger"
            (click)="deleteStateOrIncomingEvent()"
            style="width: 100%; margin-top: 10px"
            [title]="
              sharedStateOccurrence
                ? 'Remove only the event that reaches this occurrence'
                : 'Remove this state and every event into or out of it'
            ">
            <i class="fa-solid fa-trash"></i>
            {{
              sharedStateOccurrence
                ? 'Delete incoming event'
                : 'Delete state & its events'
            }}
          </button>
        </div>

        <div *ngIf="stateTab === 'json'" class="iwb-json-tab">
          <div class="dgrp">
            Transition JSON
            <span style="color: #98a2b3; font-weight: 400"
              >· event -&gt; everything</span
            >
          </div>
          <ngx-monaco-editor
            class="iwb-statejson-editor iwb-statejson-editor--tab"
            [options]="jsonEditorOptions"
            [(ngModel)]="jsonDraft"></ngx-monaco-editor>
          <div class="dnone" style="color: #b42318" *ngIf="jsonError">
            {{ jsonError }}
          </div>
          <button
            class="btn pri"
            (click)="applyStateJson()"
            style="margin-top: 8px; width: 100%">
            Apply JSON
          </button>
        </div>
      </ng-container>

      <!-- ACTION: edit just this one action (form + its own JSON) -->
      <ng-container *ngIf="target.mode === 'action' && currentAction as a">
        <div class="dcard">
          <div class="dch">
            <span class="ci" [ngClass]="meta(a).cls"
              ><i class="fa-solid" [ngClass]="meta(a).icon"></i
            ></span>
            <b>{{ meta(a).plain }}</b>
            <button
              class="ddel"
              (click)="requestActionDelete(target.actionIdx!)"
              title="Delete this action">
              🗑
            </button>
          </div>
          <div class="dbody">
            <div class="iwb-action-help">
              <div>
                <b>What it does</b>
                <p>{{ meta(a).description }}</p>
              </div>
              <div>
                <b>How to use it</b>
                <p>{{ meta(a).usage }}</p>
              </div>
            </div>
            <irembogov-iwb-notification-action-editor
              *ngIf="isNotificationAction(a); else genericActionArgs"
              [action]="a"
              [organizationId]="organizationId"
              [formFields]="
                formFields
              "></irembogov-iwb-notification-action-editor>
            <ng-template #genericActionArgs>
              <irembogov-iwb-action-args-form
                #actionArgsForm
                [action]="a"
                [organizationId]="organizationId"
                [formFields]="formFields"></irembogov-iwb-action-args-form>
              <div
                class="iwb-certificate-reminder-editor"
                *ngIf="
                  isCertificateReminderAction(a) &&
                  actionArgsForm.certificateExpiryEnabled
                ">
                <div class="dgrp">Reminder Notifications</div>
                <irembogov-iwb-notification-action-editor
                  [action]="a"
                  [argsKey]="'reminderNotifications'"
                  [organizationId]="organizationId"
                  [formFields]="formFields">
                </irembogov-iwb-notification-action-editor>
              </div>
            </ng-template>
          </div>
        </div>
        <button
          class="btn drawer-add"
          style="width: 100%; margin-top: 10px"
          (click)="onCopyAction()"
          title="Copy this action, then paste it onto another state">
          ⧉ Copy action (paste onto another state)
        </button>
      </ng-container>

      <!-- EVENT -->
      <ng-container *ngIf="target.mode === 'event'">
        <div class="dfield">
          <label>Event code</label
          ><input class="inp" [value]="t.event" disabled />
        </div>
        <button
          class="btn drawer-add"
          style="width: 100%; margin-bottom: 10px"
          (click)="onCopyEvent()">
          ⧉ Copy event (paste into a new event with ⌘V)
        </button>
        <button
          class="btn iwb-danger"
          style="width: 100%; margin-bottom: 10px"
          (click)="deleteEvent()"
          title="Remove this event and the state(s) it leads to">
          🗑 Delete event &amp; its end state(s)
        </button>
        <div class="dgrp">Authorisation</div>
        <div class="dfield dcheck">
          <label
            ><input
              type="checkbox"
              [checked]="isSystem"
              (change)="setSystem($any($event.target).checked)" />
            System authorised
            <span style="color: #667085">(no role)</span></label
          >
        </div>
        <div class="dfield" *ngIf="!isSystem">
          <label
            >Authorised roles (comma-separated)
            <span style="color: #b42318">required</span></label
          >
          <input
            class="inp"
            [value]="roles"
            (input)="setRoles($any($event.target).value)"
            placeholder="ROLE_OFFICER, ROLE_SERVICE_MANAGER" />
        </div>
        <button
          type="button"
          class="dgrp iwb-collapsible-section-title"
          (click)="toggleEventNamesExpanded()">
          <span>Event names (office-facing)</span>
          <i
            class="fa-solid"
            [ngClass]="
              eventNamesExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
            "></i>
        </button>
        <ng-container *ngIf="eventNamesExpanded">
          <div class="dfield">
            <label>Language</label>
            <select
              class="selx iwb-notification-select"
              [ngModel]="selectedEventNameLocale"
              (ngModelChange)="selectEventNameLocale($event)">
              <option
                *ngFor="let locale of localeFields; trackBy: trackByLocale"
                [value]="locale.key">
                {{ locale.label }} · {{ locale.key }}
              </option>
            </select>
          </div>
          <div class="dfield">
            <label>Event name</label>
            <input
              class="inp"
              [value]="eventName(selectedEventNameLocale)"
              (input)="
                setEventName(selectedEventNameLocale, $any($event.target).value)
              " />
          </div>
        </ng-container>
        <div
          class="iwb-locale-issue iwb-locale-issue--compact"
          *ngIf="missingEventNameLanguages().length">
          <div class="iwb-locale-issue-copy">
            <b>Missing event name translations</b>
            <p>
              Event name is set for
              {{ missingLanguageLabels(configuredEventNameLanguages()) }}
              and missing for
              {{ missingLanguageLabels(missingEventNameLanguages()) }}. Officers
              using the missing languages may see a fallback label or event
              code. Please add the missing event names.
            </p>
          </div>
        </div>

        <div class="dgrp">Outcome</div>
        <div *ngIf="!hasCondition">
          <div class="dnone" style="margin-bottom: 8px">
            This event leads to a single outcome (End State One). Add a
            condition to branch into two: <b>✓ true → End State Two</b> /
            <b>✕ false → End State One</b>.
          </div>
          <button class="btn pri" (click)="addCondition()" style="width: 100%">
            ◆ Add condition (split into two outcomes)
          </button>
        </div>

        <!-- conditional split: edit guard clauses inline (free mode has no separate diamond) -->
        <ng-container *ngIf="hasCondition">
          <div class="dfield" style="margin-bottom: 4px">
            <label
              >End State One destination
              <span style="color: #667085">(condition false)</span></label
            >
            <ng-select
              class="iwb-dest"
              [items]="stateOptions"
              bindValue="code"
              [ngModel]="outcomeOneCode"
              (change)="setOutcomeState('one', $event)"
              [searchable]="true"
              [clearable]="false"
              [searchFn]="searchState"
              [addTag]="addStateCodeTag"
              addTagText="Use custom code:"
              placeholder="Pick destination state…"
              dropdownPosition="auto">
              <ng-template ng-label-tmp let-item="item">
                <span
                  class="iwb-dot"
                  [style.background]="item.colour || 'transparent'"></span>
                <span class="iwb-opt-code">{{ item.code }}</span>
                <small
                  class="iwb-opt-name"
                  *ngIf="item.name && item.name !== item.code">
                  — {{ item.name }}</small
                >
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span
                  class="iwb-dot"
                  [style.background]="item.colour || 'transparent'"></span>
                <span class="iwb-opt-text">
                  <small
                    class="iwb-opt-name"
                    *ngIf="item.name && item.name !== item.code"
                    >{{ item.name }}</small
                  >
                  <span class="iwb-opt-code">{{ item.code }}</span>
                </span>
              </ng-template>
            </ng-select>
          </div>
          <div class="dfield" style="margin-bottom: 8px">
            <label
              >End State Two destination
              <span style="color: #667085">(condition true)</span></label
            >
            <ng-select
              class="iwb-dest"
              [items]="stateOptions"
              bindValue="code"
              [ngModel]="outcomeTwoCode"
              (change)="setOutcomeState('two', $event)"
              [searchable]="true"
              [clearable]="false"
              [searchFn]="searchState"
              [addTag]="addStateCodeTag"
              addTagText="Use custom code:"
              placeholder="Pick destination state…"
              dropdownPosition="auto">
              <ng-template ng-label-tmp let-item="item">
                <span
                  class="iwb-dot"
                  [style.background]="item.colour || 'transparent'"></span>
                <span class="iwb-opt-code">{{ item.code }}</span>
                <small
                  class="iwb-opt-name"
                  *ngIf="item.name && item.name !== item.code">
                  — {{ item.name }}</small
                >
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span
                  class="iwb-dot"
                  [style.background]="item.colour || 'transparent'"></span>
                <span class="iwb-opt-text">
                  <small
                    class="iwb-opt-name"
                    *ngIf="item.name && item.name !== item.code"
                    >{{ item.name }}</small
                  >
                  <span class="iwb-opt-code">{{ item.code }}</span>
                </span>
              </ng-template>
            </ng-select>
          </div>
          <div
            class="dnone"
            *ngIf="!clauses.length"
            style="
              background: #f4f3ff;
              border: 1px solid #e9e3ff;
              border-radius: 8px;
              padding: 8px;
              margin-bottom: 8px;
              color: #5925dc;
            ">
            ⚙ <b>System-decided.</b> The engine chooses the outcome (e.g. APPLY
            routes free applications to End State Two, paid ones to End State
            One). Add clauses below only to override with an explicit guard.
          </div>
          <div class="dnone" *ngIf="clauses.length" style="margin-bottom: 6px">
            When <b>all</b> clauses are true → <b>✓ End State Two</b>; otherwise
            → <b>✕ End State One</b>.
          </div>
          <div
            class="ccgroup"
            *ngFor="
              let c of clauses;
              let i = index;
              trackBy: trackByClauseIndex
            ">
            <div class="ccgroup-head">
              <span class="ccgroup-title">Condition {{ i + 1 }}</span>
              <button
                class="ddel"
                (click)="removeClause(i)"
                title="Remove condition">
                🗑
              </button>
            </div>
            <label class="cclabel">Field / parameter</label>
            <input
              class="inp"
              [value]="c.parameter"
              (input)="setClause(i, 'parameter', $any($event.target).value)"
              placeholder="e.g. PRICE" />
            <label class="cclabel">Comparator</label>
            <select
              class="selx"
              [value]="c.comparator"
              (change)="setClause(i, 'comparator', $any($event.target).value)">
              <option *ngFor="let cmp of comparators" [value]="cmp.code">
                {{ cmp.label }}
              </option>
            </select>
            <label class="cclabel">Value</label>
            <input
              class="inp"
              [value]="c.value"
              (input)="setClause(i, 'value', $any($event.target).value)"
              placeholder="value" />
          </div>
          <button class="addbtn" (click)="addClause()" style="margin-top: 8px">
            ＋ add guard clause
          </button>
          <button
            class="btn"
            (click)="removeCondition()"
            style="margin-top: 10px; width: 100%">
            Remove condition (back to single outcome)
          </button>
        </ng-container>
      </ng-container>

      <!-- CONDITION -->
      <ng-container *ngIf="target.mode === 'condition'">
        <div class="dfield" style="margin-bottom: 4px">
          <label
            >End State One destination
            <span style="color: #667085">(condition false)</span></label
          >
          <ng-select
            class="iwb-dest"
            [items]="stateOptions"
            bindValue="code"
            [ngModel]="outcomeOneCode"
            (change)="setOutcomeState('one', $event)"
            [searchable]="true"
            [clearable]="false"
            [searchFn]="searchState"
            [addTag]="addStateCodeTag"
            addTagText="Use custom code:"
            placeholder="Pick destination state…"
            dropdownPosition="auto">
            <ng-template ng-label-tmp let-item="item">
              <span
                class="iwb-dot"
                [style.background]="item.colour || 'transparent'"></span>
              <span class="iwb-opt-code">{{ item.code }}</span>
              <small
                class="iwb-opt-name"
                *ngIf="item.name && item.name !== item.code">
                — {{ item.name }}</small
              >
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span
                class="iwb-dot"
                [style.background]="item.colour || 'transparent'"></span>
              <span class="iwb-opt-text">
                <small
                  class="iwb-opt-name"
                  *ngIf="item.name && item.name !== item.code"
                  >{{ item.name }}</small
                >
                <span class="iwb-opt-code">{{ item.code }}</span>
              </span>
            </ng-template>
          </ng-select>
        </div>
        <div class="dfield" style="margin-bottom: 10px">
          <label
            >End State Two destination
            <span style="color: #667085">(condition true)</span></label
          >
          <ng-select
            class="iwb-dest"
            [items]="stateOptions"
            bindValue="code"
            [ngModel]="outcomeTwoCode"
            (change)="setOutcomeState('two', $event)"
            [searchable]="true"
            [clearable]="false"
            [searchFn]="searchState"
            [addTag]="addStateCodeTag"
            addTagText="Use custom code:"
            placeholder="Pick destination state…"
            dropdownPosition="auto">
            <ng-template ng-label-tmp let-item="item">
              <span
                class="iwb-dot"
                [style.background]="item.colour || 'transparent'"></span>
              <span class="iwb-opt-code">{{ item.code }}</span>
              <small
                class="iwb-opt-name"
                *ngIf="item.name && item.name !== item.code">
                — {{ item.name }}</small
              >
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span
                class="iwb-dot"
                [style.background]="item.colour || 'transparent'"></span>
              <span class="iwb-opt-text">
                <small
                  class="iwb-opt-name"
                  *ngIf="item.name && item.name !== item.code"
                  >{{ item.name }}</small
                >
                <span class="iwb-opt-code">{{ item.code }}</span>
              </span>
            </ng-template>
          </ng-select>
        </div>
        <div class="dnone" style="margin-bottom: 10px">
          When <b>all</b> clauses are true → <b>✓ End State Two</b>. Otherwise →
          <b>✕ End State One</b>.
        </div>
        <div
          class="ccgroup"
          *ngFor="let c of clauses; let i = index; trackBy: trackByClauseIndex">
          <div class="ccgroup-head">
            <span class="ccgroup-title">Condition {{ i + 1 }}</span>
            <button
              class="ddel"
              (click)="removeClause(i)"
              title="Remove condition">
              🗑
            </button>
          </div>
          <label class="cclabel">Field / parameter</label>
          <input
            class="inp"
            [value]="c.parameter"
            (input)="setClause(i, 'parameter', $any($event.target).value)"
            placeholder="e.g. PRICE" />
          <label class="cclabel">Comparator</label>
          <select
            class="selx"
            [value]="c.comparator"
            (change)="setClause(i, 'comparator', $any($event.target).value)">
            <option *ngFor="let cmp of comparators" [value]="cmp.code">
              {{ cmp.label }}
            </option>
          </select>
          <label class="cclabel">Value</label>
          <input
            class="inp"
            [value]="c.value"
            (input)="setClause(i, 'value', $any($event.target).value)"
            placeholder="value" />
        </div>
        <div class="dnone" *ngIf="!clauses.length">No clauses yet.</div>
        <button class="addbtn" (click)="addClause()" style="margin-top: 8px">
          ＋ add clause
        </button>
        <button
          class="btn"
          (click)="removeCondition()"
          style="margin-top: 10px; width: 100%">
          Remove condition
        </button>
      </ng-container>
    </div>

    <div class="dfoot">
      <button class="btn pri" (click)="saveAndClose()">
        💾 Save &amp; close
      </button>
    </div>
  </div>

  <ng-container *ngIf="integrationCallbackPrompt as callbackPrompt">
    <div
      class="iwb-confirm-backdrop"
      (click)="cancelIntegrationCallbackState()"></div>
    <div class="iwb-confirm" role="dialog" aria-modal="true">
      <div class="iwb-confirm-title">
        What is the state where the integration should go to when completed?
      </div>
      <div class="iwb-confirm-body">
        <p>
          The integration waits for a <b>PUSH</b> callback from
          <b>{{ callbackPrompt.currentStateCode }}</b
          >. Choose the state the application should move to after that
          callback.
        </p>
        <div class="dfield">
          <label>Completed state</label>
          <input
            class="inp"
            [(ngModel)]="integrationCallbackSearch"
            (input)="integrationCallbackError = ''"
            placeholder="Search or type a different state…" />
          <div class="iwb-callback-state-list">
            <button
              type="button"
              class="iwb-callback-state-option"
              *ngFor="
                let item of filteredIntegrationCompletionStateOptions;
                trackBy: trackByStateCode
              "
              (click)="onIntegrationCallbackStatePicked(item)">
              <span
                class="iwb-dot"
                [style.background]="item.colour || 'transparent'"></span>
              <span class="iwb-opt-text">
                <small
                  class="iwb-opt-name"
                  *ngIf="item.name && item.name !== item.code"
                  >{{ item.name }}</small
                >
                <span class="iwb-opt-code">{{ item.code }}</span>
              </span>
            </button>
            <button
              type="button"
              class="iwb-callback-state-option"
              *ngIf="
                integrationCallbackSearch.trim() &&
                !filteredIntegrationCompletionStateOptions.length
              "
              (click)="useCustomIntegrationCallbackState()">
              <span
                class="iwb-dot"
                [style.background]="defaultStateColour"></span>
              <span class="iwb-opt-text">
                <small class="iwb-opt-name">Use custom state</small>
                <span class="iwb-opt-code">{{
                  addStateCodeTag(integrationCallbackSearch).code
                }}</span>
              </span>
            </button>
          </div>
        </div>
        <p class="iwb-confirm-none" *ngIf="integrationCallbackError">
          {{ integrationCallbackError }}
        </p>
      </div>
      <div class="iwb-confirm-actions">
        <button class="btn pri" (click)="cancelIntegrationCallbackState()">
          Get back
        </button>
        <button
          class="btn"
          [disabled]="!canConfirmIntegrationCallbackState"
          (click)="confirmIntegrationCallbackState()">
          Use selected state
        </button>
      </div>
    </div>
  </ng-container>
</div>
